import React, { useContext } from 'react'
import Classes from './SliderCard.module.css'
import { useNavigate } from 'react-router-dom';

export default function SliderCard({ Product }) {
  const navigateTo = useNavigate();
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);
  const handleImageLoad = () => {
    setIsImageLoaded(true);
  };

  return (
    <div className={Classes.card} >
      <div className={Classes.imageHeader}>
        <div className={Classes.favCon}>
          {/* <UnfilledHeart height='15px' fill='#353535' /> */}
        </div>
        {/* <button
          className={Classes.orderBtn}
          onClick={() => handleAddToCart(Product)}
        >
          <h5>Add to Bag</h5>
        </button> */}
      </div>

      <img
        src={isImageLoaded ? Product?.images[0] : '/images/placeholder.png'}
        alt={Product?.title}
        className={Classes.productImage}
        draggable={false}
        rel="noopener noreferrer"
        onClick={() => { navigateTo(`/product/${Product.id}`) }}
        onLoad={handleImageLoad}
        loading="lazy"
      />
      <h5 className={Classes.title1} > {Product?.title} </h5>
      <h5 className={Classes.title2} > {Product?.subTitle} </h5>
      <h5 className={Classes.text2} > {Product?.images?.length} Colors </h5>
      <h5 className={Classes.price} > AED {Product?.price} </h5>
    </div>
  )
}
